'use client';

import { useRouter, useParams } from 'next/navigation'
import { GiDisc } from "react-icons/gi";
import { IoMdHappy } from "react-icons/io";

// import Link from "next/link";
import global from "../globals.css"

// DOM properties must be in camelCase.
export default function Page() {

    const router = useRouter();
    const { id } = useParams();

    return (
        <section className="grid grid-cols-1">
            <div className="flex flex-row space-x-2 border-none m-1">
                <div className="w-1/5 flex-auto flex-row box-border border-2 rounded-xl border-solid">
                    <div className="border-none m-2">Main 01</div>
                </div>
                <div className="w-3/5 flex-auto flex-row box-border border-2 rounded-xl border-solid">
                    <section className="grid grid-cols-1 border-none m-2">
                        <div className="flex-auto flex-row box-border border-2 rounded-xl border-solid m-2">
                            <div className="border-none m-2">Main 02 L1</div>
                            <div className="border-none m-2">Main 02 L2</div>
                            <div className="border-none m-2">Main 02 L3</div>
                            <div className="border-none m-2">Main 02 L4</div>
                            <div className="border-none m-2">Main 02 L5</div>
                            <div className="border-none m-2">Main 02 L6</div>
                        </div>
                        <div className="flex-auto flex-row box-border border-2 rounded-xl border-solid m-2">
                            <div className="border-none m-2">Main 02 L7</div>
                            
                        </div>
                    </section>
                </div>
                <div className="w-1/5 flex-auto flex-row box-border border-2 rounded-xl border-solid">
                    <div className="border-none m-2">Main 03</div>
                </div>
            </div>
        </section> 
        
    );
}